import {BaseComponent} from "./BaseComponent";
import {inject, Injectable} from "@angular/core";
import {MatDialogRef} from "@angular/material/dialog";

@Injectable()
export abstract class BaseDialogComponent<T> extends BaseComponent {

  protected dialogRef = inject(MatDialogRef<T>);

  protected constructor() {
    super();
    this.dialogRef.disableClose = true;
  }

  protected closeDialog(dialogResult: any) {
    this.dialogRef.close(dialogResult);
  }
}
